import { type AxiosInstance } from 'axios';
import { propEq } from 'ramda';

import { DROP_LAST_VISITED } from '@framework/constants/parameters';
import { api } from '@framework/constants/user.endpoints';
import { ROOMS_LAST_VISITED_UI } from '@framework/constants/userStates';
import { type Handler } from '@framework/server/middleware';
import { serverUrlBuilder } from '@framework/server/utils';

import { type NextPageContext } from '@type/next';
import { type UserState } from '@type/user';

const parameterActions: Record<
    string,
    (ctx: NextPageContext, axiosServer: AxiosInstance) => Promise<void>
> = {
    [DROP_LAST_VISITED]: async (_ctx, axiosServer) => {
        const url = serverUrlBuilder(api.userState());

        const currentStates = await axiosServer.get<{
            results: UserState[];
        }>(url);
        const lastVisitedUIState = currentStates.data.results.find(
            propEq(ROOMS_LAST_VISITED_UI, 'stateName')
        );

        if (lastVisitedUIState) {
            await axiosServer.patch(url, {
                states: [
                    {
                        ...lastVisitedUIState,
                        value: ''
                    }
                ]
            });
        }
    }
};

const parameterMiddleware: Handler<[], void> = async (ctx, { axiosServer, getState }) => {
    if (!ctx.req || !ctx.req.query) {
        return;
    }

    const { authenticationStatus } = getState();

    if (!authenticationStatus?.isAuthenticated) {
        return;
    }

    const queryKeys = Object.keys(ctx.req.query);
    const filteredSideEffects = queryKeys.filter((key) => {
        if (!ctx.req || !ctx.req.query) {
            return false;
        }
        return ctx.req.query[key] && parameterActions[key];
    });
    const sideEffects = filteredSideEffects.map((key) => parameterActions[key](ctx, axiosServer));

    await Promise.all(sideEffects);
};

export default parameterMiddleware;
